import { useEffect, useState } from 'react';

export const ELECTION_DATE = new Date('2026-05-30T07:00:00+02:00');
// Polls close 15 hours after they open — Saturday 22:00 local Malta
// time. Used by Hero when phase === 'polls_open' to count down to
// the close rather than to election day.
export const POLLS_CLOSE_DATE = new Date('2026-05-30T22:00:00+02:00');

export function daysUntil(target: Date = ELECTION_DATE, now: Date = new Date()): number {
  const ms = target.getTime() - now.getTime();
  if (ms <= 0) return 0;
  return Math.ceil(ms / 86_400_000);
}

export function useCountdown(target: Date = ELECTION_DATE): number {
  const [days, setDays] = useState(() => daysUntil(target));

  useEffect(() => {
    const tick = () => setDays(daysUntil(target));
    tick();
    const id = window.setInterval(tick, 60_000);
    return () => window.clearInterval(id);
  }, [target]);

  return days;
}

// ── Fine-grained countdown (hours/minutes) for within-the-day timers
//   like Hero's polls-close ticker. Uses a 30s tick so the minute
//   readout flips on time without burning unnecessary renders.
export interface TimeRemaining {
  hours: number;
  minutes: number;
  expired: boolean;
}

export function timeUntil(target: Date, now: Date = new Date()): TimeRemaining {
  const ms = target.getTime() - now.getTime();
  if (ms <= 0) return { hours: 0, minutes: 0, expired: true };
  return {
    hours: Math.floor(ms / 3_600_000),
    minutes: Math.floor((ms % 3_600_000) / 60_000),
    expired: false,
  };
}

export function useTimeUntil(target: Date): TimeRemaining {
  const [r, setR] = useState(() => timeUntil(target));

  useEffect(() => {
    const tick = () => setR(timeUntil(target));
    tick();
    const id = window.setInterval(tick, 30_000);
    return () => window.clearInterval(id);
  }, [target]);

  return r;
}
